export const rootButton = {
    padding:"8px 50px",
    borderRadius:"25px",
    backgroundColor:"#007dc6",
    border:"none",
    color:"white",
    fontSize:"16px"
}